import { COURSE_REQUEST } from '../actions';

export default function(state=null, action){
  switch (action.type) {
    case COURSE_REQUEST:
      return action.payload.data;
    default:
      return state;
  }
}


  /*if (state==null) {
    return {
      id: 1,
      titulo: "Titulo del curso",
      descripcion: "Descripcion para el curso de prueba para saber si funciona.",
      img: "https://samueleresca.net/wp-content/uploads/2015/05/bootstrap-social.png",
      costo: 100000,
      modulos: [
        { id: 1, nombre: "modulo de prueba 1", descripcion: "descripcion del primer modulo de prueba para ver" },
        { id: 2, nombre: "modulo de prueba 2", descripcion: "descripcion del segundo modulo de prueba para ver" },
        { id: 3, nombre: "modulo de prueba 3", descripcion: "descripcion del tercer modulo de prueba para ver" },
        { id: 4, nombre: "modulo de prueba 4", descripcion: "descripcion del cuarto modulo de prueba para ver" }
      ]
    };
  }*/



// WEBPACK FOOTER //
// ./src/reducers/curso_reducer.js